import { Loader } from "semantic-ui-react";

import "components/OverlayLoader/OverlayLoader.scss";

export const OverlayLoader = () => (
  <div className="OverlayLoader__container">
    <Loader active />
  </div>
);
